import { createFileRoute } from '@tanstack/react-router';
import { RequireMeasurements } from '../components/RequireMeasurements.js';

export const Route = createFileRoute('/_planner/planner/lock')({
  component: () => <RequireMeasurements allowUnverifiedCatalogue />,
});
